import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { translate, showMessageToastCustom, isNullOrEmpty, formatDate } from "../../utils/util";
import ButtonUI from "../../components/UI/ButtonUI";
import InputUI from "../../components/UI/InputUI";
import Select from "../../components/UI/Select";
import SelectItem from "../../components/UI/SelectItem";
import { onValueChange } from "../../utils/handleChangeHooks";
import * as volumeAction from "../../actions/volumeAction";
import MdrService from "../../services/MdrService";
import VolumeService from "../../services/VolumeService";
import { now } from "moment";

const VolumeParameters = (props) => {
  const [configVolume, setConfigVolume] = useState({
    date: undefined,
    packingId: undefined,
    marketplaceId: undefined,
    registrationRequired: true
  });

  useEffect(() => {
    props.getMarketplace();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setConfigVolume({
      date: formatDate(now()),
      packingId: props.volumeConfiguration?.packingId,
      marketplaceId: props.volumeConfiguration?.marketplaceId,
      registrationRequired: props.volumeConfiguration?.registrationRequired === undefined ? true : props.volumeConfiguration?.registrationRequired
    });
    const elementpackingId = document.getElementById('packingId');
    if (elementpackingId && (props.volumeConfiguration?.packingId === 0 || props.volumeConfiguration?.packingId === undefined)) {
      elementpackingId.value = "";
    }
    // eslint-disable-next-line
  }, [props.volumeConfiguration]);

  const onChangeData = (value) => {
    if (value && value.length >= 2) {
      props.setVolumeItems({ codeIrf: value });
    }
  };

  const onChangeDataItem = (value) => {
    if (!isNullOrEmpty(value)) {
      configVolume.packingId = value;
      setConfigVolume(configVolume);
    }
  };

  const onChange = (event) => {
    onValueChange(event, configVolume, setConfigVolume);
  };

  const onConfirm = () => {
    if (isNullOrEmpty(configVolume.packingId) || isNullOrEmpty(configVolume.marketplaceId)) {
      showMessageToastCustom(translate("warning", "general"), translate("invalid-fileds", "volume"), 3000, "mdi mdi-alert-circle-outline red-text");
    } else {
      props.updateVolumeConfiguration(configVolume);
      const packing = props.packing.items.find((f) => f.rackCodeId === configVolume.packingId);
      props.updateWeight(packing);
      props.onSelectedTab(0, true);
    }
  };

  const formatDescriptionDropDown = (item) => {
    if (item) {
      return `${!isNullOrEmpty(item?.codEmbalagemIRF) ? item.codEmbalagemIRF : item.code}-${item.description}`;
    }
    return "";
  };

  return (
    <div className="container">
      <div className="row">
        <div
          className="card-content"
          style={{ padding: "7px", paddingBlockEnd: "1px", backgroundColor: "white" }}
        >
          <fieldset style={{ border: "1px solid #597dda" }}>
            <legend style={{ padding: "0 5px" }}>
              {translate("configurations", "general")}
            </legend>
            <form>
              <div className="input-field no-padding col s12">
                <InputUI
                  defaultValue={configVolume.date}
                  type="date"
                  label={translate("date", "volume")}
                  id="date"
                  name="date"
                  onChange={onChange}
                  required
                  disabled
                />
              </div>
              <div className="input-field no-padding col s12">
                <Select
                  required
                  id="marketplaceId"
                  name="marketplaceId"
                  label={translate("marketplace", "volume")}
                  change={onChange}
                  placeHolder={translate("marketplace", "volume")}
                  defaultValue={configVolume?.marketplaceId || ''}
                  data={props.marketplace ? props.marketplace?.map((i) => { return { id: i.id, text: i.description }; }) : []}
                />
              </div>
              <div className="input-field no-padding col s12">
                <SelectItem
                  required
                  id="packingId"
                  name="packingId"
                  label={translate("packing", "volume")}
                  onChange={onChangeData}
                  onChangeData={onChangeDataItem}
                  defaultValue={configVolume?.packingId || ''}
                  data={props.packing?.items ? props.packing?.items.map((i) => {
                    return { id: i.rackCodeId, text: formatDescriptionDropDown(i) };
                  }) : []}
                />
              </div>
              <div>
                <div className="input-field no-padding col s12">
                  <InputUI
                    type="checkbox"
                    label={translate("inform-registration", "volume")}
                    onChange={onChange}
                    defaultChecked={configVolume.registrationRequired}
                    id="registrationRequired"
                    name="registrationRequired"
                  />
                </div>
              </div>
            </form>
          </fieldset>
          <div className="row" style={{ paddingTop: "5px" }}>
            <ButtonUI
              onClick={() => props.history.goBack()}
              text={translate("cancel", "general")}
              secundary="true"
            />
            <ButtonUI
              onClick={() => onConfirm()}
              text={translate("confirm", "general")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
    volumeConfiguration: state.volumeReducer.volumeConfiguration,
    marketplace: state.volumeReducer.marketplace,
    packing: state.volumeReducer.packing,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateVolumeConfiguration: (item) => {
      dispatch(volumeAction.UpdateVolumeConfiguration(item));
    },
    setVolumeItems: (filter) => {
      dispatch(MdrService.getVolume(filter));
    },
    getMarketplace: () => {
      dispatch(VolumeService.getMarketplaces());
    },
    getVolumeType: () => {
      dispatch(VolumeService.getVolumeType());
    },
    updateWeight: (packing) => {
      dispatch(volumeAction.updateWeight(packing));
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VolumeParameters));
